import styled from "styled-components";

export const FlexHorizontalContainer = styled.div<{ columnGap?: string }>`
  display: flex;
  column-gap: ${(props) => props.columnGap};
`;

export const FlexVerticalContainer = styled.div<{ rowGap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.rowGap};
  width: 100%;
`;

export const SectionContainer = styled.div`
  padding: 0px 24px;
`;
